'use strict';

/* eslint no-prototype-builtins: "off" */

const _ = require('lodash');

const RequestHandler = require('./../../../core/requestHandler');
const container = require('./../../../core/container');

let page = {};

page.getTypes = function(context) {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.read(`pages-types?context=${context}`);
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.getCategories = function() {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.read('page-categories');
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.getAuthorizedCategories = function(type) {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.read('user-rights/current-user-authorized-categories', {'contextual_page_type': type});
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.get = function(criteria, includePageUid = true) {
    let result;

    RequestHandler.setBaseUrl('/api');

    if (includePageUid) {
        criteria['page_uid'] = container.get('page.uid');
    }

    result = RequestHandler.read('pages', criteria);
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};


page.getAssociatedPages = (uid) => {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.read('multilang/associated-pages/', {'uid': uid});
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.removeAssociatePage = (uid) => {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.del(`multilang/associated-pages/${uid}`);
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.associatePage = (uid, associatePageUid) => {
    let result;

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.update(`multilang/associated-pages/${uid}`, {'targetpageuid': associatePageUid});
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.find = function(uid) {
    let result;

    RequestHandler.setBaseUrl('/api');

    if (!_.isString(uid)) {
        throw new Error('Uid missing');
    }

    result = RequestHandler.read('pages/', {'uid': uid});
    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.duplicate = function(data, pageUid) {
    let result;

    pageUid = pageUid || container.get('page.uid');

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.create('pages/duplicate/' + pageUid, data);

    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.save = function(data, criteria) {
    let result;

    criteria = criteria || {};
    RequestHandler.setBaseUrl('/api');

    if (criteria.hasOwnProperty('uid')) {
        result = RequestHandler.update('pages/', data, criteria);
    } else {
        result = RequestHandler.create('pages', data);
    }

    RequestHandler.setBaseUrl('/rest/2');

    return result;
};

page.delete = function(uid) {
    return RequestHandler.del('page', {'uid': uid});
};

module.exports = page;
